import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { DateRangePicker } from "react-date-range";
// import { NavItem } from "reactstrap";
import CustomStaticRangeLabelContent from "../CustomStaticRangeLabelContent";
import {
  getCurrentDay,
  getSelectedMonthAgoWithFirstDay,
} from "../../../../helpers/utils";

const renderStaticRangeLabel = props => (
  <CustomStaticRangeLabelContent text={props.label} />
);

const DateRange = props => {
  const [staticRanges, setStaticRanges] = React.useState([
    {
      label: "3 Month",
      hasCustomRendering: false,
      range: () => ({
        startDate: new Date(getSelectedMonthAgoWithFirstDay(3)),
        endDate: new Date(getCurrentDay()),
      }),
      isSelected: () => false,
    },
    {
      label: "Half year",
      hasCustomRendering: false,
      range: () => ({
        startDate: new Date(getSelectedMonthAgoWithFirstDay(6)),
        endDate: new Date(getCurrentDay()),
      }),
      isSelected: () => false,
    },
    {
      label: "9 Month",
      hasCustomRendering: false,
      range: () => ({
        startDate: new Date(getSelectedMonthAgoWithFirstDay(9)),
        endDate: new Date(getCurrentDay()),
      }),
      isSelected: () => false,
    },
    {
      label: "Year",
      hasCustomRendering: false,
      range: () => ({
        startDate: new Date(getSelectedMonthAgoWithFirstDay(12)),
        endDate: new Date(getCurrentDay()),
      }),
      isSelected: () => false,
    },
  ]);
  const [settings, setSettings] = React.useState({});

  React.useEffect(() => {
    if (props.customStaticRanges) {
      setSettings({
        renderStaticRangeLabel,
        staticRanges: staticRanges,
      });
    }
  }, []);

  const params = {
    ...(props?.maxDate && {
      maxDate: new Date(props.maxDate),
    })
  }

  return (
    <StyledRangePicker
      {...settings}
      id={`drop-down-calendar`}
      onChange={item => props.onChange(item)}
      showSelectionPreview={true}
      months={props.customStaticRanges ? 1 : props.style.width < 1700 ? 1 : 2}
      ranges={props.state.length > 0 && props.state}
      direction={props.style.width > 1700 ? "horizontal" : "vertical"}
      styledStyle={props.style}
      {...params}
    />
  );
};

const StyledRangePicker = styled(DateRangePicker)`
  position: absolute;
  z-index: 999999;
  left: ${options => (options.styledStyle.right > 1000 ? "auto" : "0")};
  right: ${options => (options.styledStyle.right > 1000 ? "0" : "auto")};
  border: 1px solid rgba(0, 0, 0, 0.1);
  margin-top: 15px;
  border-radius: 5px 0px 5px 5px;

  .rdrDefinedRangesWrapper {
    border-radius: 5px 0px 0px 5px;
    transition-duration: 0.5s;

    display: ${options => (options.styledStyle.width > 1131 ? "flex" : "none")};

    .rdrStaticRanges {
      border-top-left-radius: 5px;
      width: 100%;
      /* justify-content: center; */
      vertical-align: middle;

      .rdrStaticRange {
        span {
          color: #495057;
          font-family: "Poppins", sans-serif;
          font-weight: 400;
          font-size: 13px;
          padding: 16.5px 0;
          text-align: center;
        }
      }

      .rdrStaticRangeSelected {
        span {
          color: #3d91ff;
        }
      }

      .rdrStaticRange:nth-child(1) {
        /* border-top: 1px solid #eff2f7; */
        border-top-left-radius: 5px;
        .rdrStaticRangeLabel:nth-child(1) {
          border-top-left-radius: 5px;
        }
      }
    }
    .rdrInputRanges {
      display: none;
      .rdrInputRange {
        span {
          width: 50%;
          font-size: 8.5px;
          color: #495057;
          font-weight: 500;
          font-family: "Poppins", sans-serif;
        }
      }
    }
  }

  .rdrCalendarWrapper {
    border-radius: ${options =>
      options.styledStyle.width > 610 ? "5px 0px 5px 0px" : "5px 0px 5px 5px"};
    .rdrDateDisplayWrapper {
      border-top-left-radius: ${options =>
        options.styledStyle.width > 610 ? "0" : "5px"};

      .rdrDateDisplay {
        .rdrDateInput {
          input {
            border-radius: 4px;
          }
        }
      }
    }
  }

  &::after {
    content: "";
    top: ${options =>
      options.styledStyle.bottom < 400
        ? "-13px"
        : options.styledStyle.width < 1700
        ? "353px"
        : "391px"};
    transform: ${options =>
      options.styledStyle.bottom < 400 ? "rotate(0deg)" : "rotate(180deg)"};
    left: ${options => (options.styledStyle.right > 1000 ? "auto" : "3px")};
    right: ${options => (options.styledStyle.right > 1000 ? "3px" : "auto")};
    position: absolute;
    border: 6px solid transparent;
    border-bottom: 6px solid rgba(0, 0, 0, 0.1);
  }
`;

DateRange.propTypes = {
  style: PropTypes.object,
  state: PropTypes.any,
  onChange: PropTypes.func,
  customStaticRanges: PropTypes.bool,
  maxDate: PropTypes.string
};

export default DateRange;
